(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($q, $injector, $localStorage, $sessionStorage) {
        return {
            responseError: responseError
        };

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                // SUP-12293: the access of this account has ended; the sign-in dialog says so instead of a generic error
                if (response.data && response.data.title === 'accessExpired') {
                    $sessionStorage.accessExpired = { accessValidUntil: response.data.accessValidUntil || null };
                }
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            } else if (response.status === 403 && response.data &&
                (response.data.title === 'archiveOnly' || response.data.title === 'noAccessRole')) {
                // SUP-12293: the account's roles changed while this screen was open; reload them and go where they lead
                // instead of leaving an empty list or a generic error on screen
                reloadIdentity();
            }
            return $q.reject(response);
        }

        function reloadIdentity() {
            var Principal = $injector.get('Principal');
            var $state = $injector.get('$state');
            Principal.identity(true).then(function () {
                var home = Principal.homeState();
                if ($state.current.name !== home) {
                    $state.go(home);
                }
            });
        }
    }
})();
